export enum Color {
  brandGreen = '#26742C',
  lightGreen = '#D8F6DA',
  offWhite = '#FAFCF7',
  white = '#FFFFFF',
  gray = '#FAFAFA',
  darkgray = '#6B6B6B',
  footerGray = '#333333',
  black = '#2D322B',
  blue = '#185682',
  red = '#FED7D7',
  darkred = '#9B2C2C',
  lightOrange = '#FEEBCB',
  orange = '#C05621',
  claimGray = '#8C8F93',
}

export enum InfoBoxStatus {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export function getColorForStatus(status: InfoBoxStatus) {
  switch (status) {
    case InfoBoxStatus.SUCCESS:
      return Color.brandGreen;
    case InfoBoxStatus.WARNING:
      return Color.orange;
    case InfoBoxStatus.ERROR:
      return Color.darkred;
    default:
      return Color.brandGreen;
  }
}
